import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const NAVY = '#0A1F44';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [status, setStatus] = useState('verifying'); // verifying | success | error

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    axios.post(`${API}/auth/verify-email`, { token })
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: '#F5F1E8' }}>
      <div className="w-full max-w-md bg-white rounded-3xl p-8 shadow-xl text-center" data-testid="verify-email-page">
        {status === 'verifying' && (
          <>
            <Loader2 className="w-10 h-10 mx-auto mb-4 animate-spin" style={{ color: '#C0975C' }} />
            <p style={{ color: NAVY }}>Verifying your email…</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle2 className="w-12 h-12 mx-auto mb-4" style={{ color: '#16a34a' }} />
            <h1 className="text-2xl font-bold mb-2" style={{ color: NAVY, fontFamily: 'Outfit, sans-serif' }}>Email verified</h1>
            <p className="text-sm mb-6" style={{ color: '#4a5568' }}>Thank you. Your Precision Wealth account email is confirmed.</p>
            <Link to="/dashboard" className="inline-block px-6 py-3 rounded-full font-bold text-white" style={{ background: NAVY }}>Go to dashboard</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-12 h-12 mx-auto mb-4" style={{ color: '#dc2626' }} />
            <h1 className="text-2xl font-bold mb-2" style={{ color: NAVY, fontFamily: 'Outfit, sans-serif' }}>Link invalid or expired</h1>
            <p className="text-sm mb-6" style={{ color: '#4a5568' }}>This verification link is no longer valid. You can request a new one from your profile after signing in.</p>
            <Link to="/auth" className="inline-block px-6 py-3 rounded-full font-bold text-white" style={{ background: NAVY }}>Sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
